<template>
    <bottom-sheet v-model="shows" persistent max-width="1200" title="리본바이옴 판매 계약서">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <div style="flex: 1; overflow: hidden">
            <employment-doc-view
                v-bind="{
                    contract: form,
                    value: fields,
                    pages,
                    mode: 'done',
                }"
                ref="employment-doc-view"
            />
        </div>

        <template #foot>
            <v-row class="ma-n2" v-if="hasFile">
                <v-col class="pa-2" cols="6">
                    <view-file v-model="form">
                        <template #activator="{ attrs, on }">
                            <v-btn block color="primary" outlined class="v-size--xx-large" v-bind="attrs" v-on="on">첨부파일 확인</v-btn>
                        </template>
                    </view-file>
                </v-col>
                <v-col class="pa-2" cols="6">
                    <v-btn block color="primary" class="v-size--xx-large" @click="down">계약서 다운로드</v-btn>
                </v-col>
            </v-row>
            <template v-else>
                <v-btn block color="primary" class="v-size--xx-large" @click="down">계약서 다운로드</v-btn>
            </template>
        </template>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import BottomSheet from "@/components/client/dumb/bottom-sheet.vue";
import EmploymentDocView from "@/components/client/employment/doc/employment-doc-view.vue";
import ViewFile from "./view/view-file.vue";

export default {
    components: {
        BottomSheet,
        EmploymentDocView,
        ViewFile,
    },
    data: () => ({
        form: initEmploymentContract(),

        shows: false,
        loading: false,
    }),
    computed: {
        fields() {
            return [...this.form.fields_document, ...this.form.fields_employee];
        },
        pages() {
            return this.form?.form?.pages || [];
        },
        hasFile() {
            return this.form.fields_employee.some((item) => item.type == EMPLOYMENT_FIELD_TYPES.FILE.value);
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { contract } = await api.v1.me.employment.contract.get();
                this.form = initEmploymentContract(contract);
            } finally {
                this.loading = false;
            }
        },
        down() {
            this.$refs["employment-doc-view"]?.down?.();
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped></style>
